import { CheckSquare, ShoppingBag, CalendarDays, Lightbulb } from 'lucide-react';
import { dayKey, noteCalendarDate } from './calendarDates';
export const categories = [
  { name: 'To Do', icon: CheckSquare, color: 'blue', description: 'One thing at a time' },
  { name: 'Shopping', icon: ShoppingBag, color: 'green', description: 'For your next trip' },
  { name: 'Appointments', icon: CalendarDays, color: 'coral', description: 'Make time for it' },
  { name: 'Ideas', icon: Lightbulb, color: 'gold', description: 'Keep the spark' },
];
export const slug = value => value.toLowerCase().replace(/[^a-z0-9]+/g, '-');
export function bucket(note) {
  const placement = noteCalendarDate(note);
  if (!placement) return 'Unscheduled';
  return placement.day > dayKey(new Date()) ? 'Upcoming' : 'Today';
}
export function formatDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date)) return '';
  const today = new Date();
  const tomorrow = new Date(); tomorrow.setDate(tomorrow.getDate() + 1);
  const day = date.toDateString() === today.toDateString() ? 'Today' : date.toDateString() === tomorrow.toDateString() ? 'Tomorrow' : date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `${day}, ${date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}`;
}
export function entitlement(user) {
  return user?.lifetime_free === true ? 'Lifetime Free' : 'Free Access — No payment required.';
}